export default __webpack_public_path__ + "static/media/bubble-ball.eb21acbc.svg";